import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Typography,
} from "@material-tailwind/react";
import { GobbyTable, GobbyTableHead, GobbyTableBody, GobbyTableRow, GobbyTableHeader, GobbyTableCell } from "components/ui/gobby-table";

export default function RespondentResponseSentimentListDialog({
    showRespondentResponseSentimentListDialog,
    setShowRespondentResponseSentimentListDialog,
    responseSentimentListId,
    setResponseSentimentListId,
    respondentSentimentData,
}) {
    const handleClose = () => {
        setShowRespondentResponseSentimentListDialog((showRespondentResponseSentimentListDialog) => !showRespondentResponseSentimentListDialog);
    };
    const percentFormat = (decimal) => {
        let formattedPercent;
        if (Number.isFinite(decimal)) {
            formattedPercent = Intl.NumberFormat("default", {
                style: "percent",
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }).format(decimal);
        } else {
            formattedPercent = "N/A";
        }
        return formattedPercent;
    };

    return (
        <Dialog
            className="dialog"
            open={showRespondentResponseSentimentListDialog}
            handler={handleClose}
        >
            <DialogHeader className="dialog__header">
                Responses Sentiment
            </DialogHeader>
            <DialogBody className="dialog__body">
                <Typography className="py-2 font-body text-black">
                    A list of sentiment by individual response text with the
                    response text ID.
                </Typography>
                <div className="p-2 mt-2 rounded-lg bg-white w-full">
                    <GobbyTable>
                        <GobbyTableHead className="text-sm sm:text-lg border-gray-300">
                            <GobbyTableRow>
                                <GobbyTableHeader className="w-1/12">
                                    ID
                                </GobbyTableHeader>
                                <GobbyTableHeader className="w-7/12">
                                    Response Text
                                </GobbyTableHeader>
                                <GobbyTableHeader className="w-1/12">
                                    Positive
                                </GobbyTableHeader>
                                <GobbyTableHeader className="w-1/12">
                                    Neutral
                                </GobbyTableHeader>
                                <GobbyTableHeader className="w-1/12">
                                    Negative
                                </GobbyTableHeader>
                                <GobbyTableHeader className="w-1/12">
                                    Mixed
                                </GobbyTableHeader>
                            </GobbyTableRow>
                        </GobbyTableHead>
                        {!!respondentSentimentData && (
                            <GobbyTableBody className="">
                                {respondentSentimentData?.data?.[
                                    responseSentimentListId
                                ]?.responses_with_sentiment?.map(
                                    (response, index) => (
                                        <GobbyTableRow
                                            key={response.response_id}
                                        >
                                            <GobbyTableCell className="text-center">
                                                {response.response_id}
                                            </GobbyTableCell>
                                            <GobbyTableCell className="text-left">
                                                {response.text}
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`${
                                                        response.sentiment
                                                            .positive_score ===
                                                        response.sentiment.score
                                                            ? "font-bold bg-green-200 rounded-full text-center border-white border border-2"
                                                            : ""
                                                    }`}
                                                >
                                                    {percentFormat(
                                                        response.sentiment
                                                            .positive_score,
                                                    )}
                                                </span>
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`${
                                                        response.sentiment
                                                            .neutral_score ===
                                                        response.sentiment.score
                                                            ? "font-bold bg-green-200 rounded-full text-center border-white border border-2"
                                                            : ""
                                                    }`}
                                                >
                                                    {percentFormat(
                                                        response.sentiment
                                                            .neutral_score,
                                                    )}
                                                </span>
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`${
                                                        response.sentiment
                                                            .negative_score ===
                                                        response.sentiment.score
                                                            ? "font-bold bg-green-200 rounded-full text-center border-white border border-2"
                                                            : ""
                                                    }`}
                                                >
                                                    {percentFormat(
                                                        response.sentiment
                                                            .negative_score,
                                                    )}
                                                </span>
                                            </GobbyTableCell>
                                            <GobbyTableCell>
                                                <span
                                                    className={`${
                                                        response.sentiment
                                                            .mixed_score ===
                                                        response.sentiment.score
                                                            ? "font-bold bg-green-200 rounded-full text-center border-white border border-2"
                                                            : ""
                                                    }`}
                                                >
                                                    {percentFormat(
                                                        response.sentiment
                                                            .mixed_score,
                                                    )}
                                                </span>
                                            </GobbyTableCell>
                                        </GobbyTableRow>
                                    ),
                                )}
                            </GobbyTableBody>
                        )}
                    </GobbyTable>
                </div>
            </DialogBody>
            <DialogFooter className="dialog__footer">
                <div className="mt-4">
                    <Button
                        type="button"
                        className="btn btn--secondary"
                        variant="filled"
                        size="lg"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </div>
            </DialogFooter>
        </Dialog>
    );
}
